import(/* webpackMode: "eager", webpackExports: ["ArticleContent"] */ "/vercel/path0/app/blog/[handle]/article-content.tsx");
